import { FC, useState } from "react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import { useGiftcardsListing } from "../../context/GiftcardsListingContext";
import { track } from "@amplitude/analytics-browser";
import { useDebounce } from "src/hooks/useDebounce";
import { SearchIcon } from "src/assets/Icons";

const GiftcardsSearch: FC<{ name: string }> = ({ name }) => {
  const { t } = useTranslation();
  const { setFilters } = useGiftcardsListing();
  const [value, setValue] = useState("");

  useDebounce(value, {
    delay: 300,
    skipFirstRender: true,
    callBack: (debouncedValue) => {
      track("Search Submitted", { value: debouncedValue, name });
      setFilters((prev) => ({ ...prev, [name]: debouncedValue }));
    },
  });

  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={t("Giftcards.searchPlaceholder")}
      className="bg-background-default! h-13! py-0! ps-7! pe-3! border-none! flex! items-center! rounded-xs! outline-none!"
      
      size="large"
    />
  );
};

export default GiftcardsSearch;
